import { render, staticRenderFns } from "./ProductTypeGroupMergeForm.vue?vue&type=template&id=70740969&scoped=true"
import script from "./ProductTypeGroupMergeForm.vue?vue&type=script&lang=js"
export * from "./ProductTypeGroupMergeForm.vue?vue&type=script&lang=js"
import style0 from "./ProductTypeGroupMergeForm.vue?vue&type=style&index=0&id=70740969&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70740969",
  null
  
)

export default component.exports